module.exports = __webpack_public_path__ + "static/media/test1_1.ab07147f.png";